import { loadScriptOnce } from '@hyphengroup/cms-components/utils/loadScriptOnce';
import { useEffect } from 'react';
import { YOUTUBE_SCRIPT } from './constants';
import { EnumVideoBlockEmbedType } from '$/(cms)/_modules/cmsService/types';

export const useYouTubeApi = (
  embedType: EnumVideoBlockEmbedType | null | undefined,
  isPlaying: boolean,
) => {
  useEffect(() => {
    if (embedType !== EnumVideoBlockEmbedType.Youtube || !isPlaying) return;

    loadScriptOnce(YOUTUBE_SCRIPT).catch(() => undefined);
  }, [embedType, isPlaying]);
};
